import ConditionSymbolizer from "./ConditionSymbolizer.js";
function processBlueprints(molten, blueprints) {
  blueprints.forEach(blueprint => {
    molten.addPlugin('MapBoxSymbolizer', {
      type: ConditionSymbolizer.TYPE,
      objectType: blueprint.type,
      name: 'Condition Symbolizer',
      symbolizer: ConditionSymbolizer
    });
  });
}
export default {
  id: 'molten.imagine.ConditionSymbolizerBlueprintProcessor',
  processBlueprints
};